<div class="flex-fill d-flex flex-row">
  <div class="d-flex flex-column flex-shrink-0 sidebar">
    <div class="d-flex justify-content-center border-bottom">
      <div class="m-3">Great Plains</div>
    </div>
    @if (filter) {
      <dx-form
        [formData]="filter"
        class="d-flex flex-column align-items-center mt-3"
        (onEditorEnterKey)="refresh()"
        appAutofocusForm="companyName"
        >
        <dxi-form-item
          dataField="selectedEntityType"
          editorType="dxSelectBox"
          [label]="{ text: 'Type' }"
          [editorOptions]="{ items: types, disabled: processing }"
        ></dxi-form-item>
        <dxi-form-item>
          <div *dxTemplate>
            <button class="btn btn-success d-flex m-auto" (click)="refresh()">Refresh Data</button>
          </div>
        </dxi-form-item>
      </dx-form>
    }
  </div>
  <div class="d-flex flex-fill flex-column dx-card">
    <div class="d-flex flex-fill flex-column p-3">
      <div class="d-flex flex-column flex-fill">
        <dx-data-grid
          #dataGrid
          [keyExpr]="'id'"
          class="flex-fill d-flex flex-column"
          height="100px"
          [dataSource]="data"
          [showBorders]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          [columnAutoWidth]="true"
          >
          <dxi-data-grid-column
            dataField="id"
            caption="{{ filter.selectedEntityType }} Id"
            cellTemplate="linkTemplate"
            width="100"
          ></dxi-data-grid-column>
          <dxi-data-grid-column
            [visible]="filter.selectedEntityType === 'Invoice'"
            dataField="invoiceNumber"
            caption="Inv#"
            cellTemplate="linkTemplate"
            width="70"
          ></dxi-data-grid-column>

          <dxi-data-grid-column
            [visible]="filter.selectedEntityType === 'Invoice'"
            dataField="customer.displayName"
            caption="Customer"
            cellTemplate="linkTemplate"
            width="250"
          ></dxi-data-grid-column>
          <dxi-data-grid-column
            [visible]="filter.selectedEntityType === 'Invoice'"
            dataField="customer.quickBooksId"
            caption="SET GPId"
            width="150"
          ></dxi-data-grid-column>
          <dxi-data-grid-column
            [visible]="filter.selectedEntityType === 'Invoice'"
            dataField="batchNumber"
            caption="Batch #"
            width="150"
          ></dxi-data-grid-column>
          <dxi-data-grid-column
            [visible]="filter.selectedEntityType === 'Invoice'"
            dataField="total"
            [format]="{ type: 'currency', precision: 2 }"
            caption="Amount"
            width="70"
          ></dxi-data-grid-column>
          <dxi-data-grid-column
            [visible]="filter.selectedEntityType === 'Invoice'"
            dataField="invoiceDate"
            caption="Invoice Date"
            width="70"
          ></dxi-data-grid-column>
          <dxi-data-grid-column></dxi-data-grid-column>

          <div *dxTemplate="let cell of 'linkTemplate'">
            @if (cell) {
              <a
                [routerLink]="[]"
                [innerHtml]="cell.text"
                (click)="openFromQueue(cell.data, cell.column.dataField)"
              ></a>
            }
          </div>

          <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="gp-entity-grid"></dxo-data-grid-state-storing>

          <div *dxTemplate="let data of 'toolbarButtons'">
            <button
              class="btn btn-success me-1 mb-2"
              (click)="export()"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Export Selected
            </button>
            <button class="btn btn-success me-1 mb-2" (click)="export(true)">Export All</button>
            <button
              class="btn btn-success me-1 mb-2"
              (click)="printInvoices(dataGrid.instance.getSelectedRowsData())"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Print
            </button>
          </div>

          <div *dxTemplate="let data of 'toolbarText'">
            @if (data) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>

      <div class="d-flex flex-column flex-fill pt-3">
        <dx-data-grid
          #quickbooksSyncResultsGrid
          keyExpr="id"
          class="flex-fill d-flex flex-column"
          height="100px"
          [dataSource]="responses"
          [showBorders]="true"
          [showRowLines]="false"
          [focusedRowEnabled]="false"
          [columnAutoWidth]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-data-grid-column dataField="quickBooksTaskId" caption="Task Id" width="65" alignment="left"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="invoice.batchNumber" caption="Batch #" width="65" alignment="left"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="id" caption="Id" width="65" alignment="left"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="type" caption="Type" width="80"></dxi-data-grid-column>
          <dxi-data-grid-column
            dataField="invoice.customer.quickBooksId"
            caption="Customer Id"
            width="100"
            alignment="left"
            cellTemplate="linkTemplate"
          ></dxi-data-grid-column>
          <dxi-data-grid-column caption="Customer" cellTemplate="customerTemplate" width="200"></dxi-data-grid-column>
          <dxi-data-grid-column
            dataField="invoiceId"
            caption="Invoice Id"
            width="100"
            alignment="left"
            cellTemplate="linkTemplate"
          ></dxi-data-grid-column>
          <dxi-data-grid-column dataField="invoice.invoiceNumber" caption="Inv#" cellTemplate="linkTemplate" width="70"></dxi-data-grid-column>
          <dxi-data-grid-column
            dataField="paymentId"
            caption="Payment Id"
            width="100"
            alignment="left"
            cellTemplate="linkTemplate"
          ></dxi-data-grid-column>
          <dxi-data-grid-column dataField="payment.referenceNumber" caption="Ref #" cellTemplate="linkTemplate" width="70"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="message" alignment="left"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="status" width="100" alignment="left"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="created" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="invoice.invoiceDate" caption="Invoice Date" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column></dxi-data-grid-column>

          <div *dxTemplate="let cell of 'customerTemplate'">
            @if (cell) {
              <a [routerLink]="[]" (click)="open(cell.data, 'customerDisplayName')">
                {{
                cell.data.type === 'Customer'
                ? cell.data.customer.displayName
                : cell.data.type === 'Payment'
                ? cell.data.payment.customer.displayName
                : cell.data.type === 'Invoice'
                ? cell.data.invoice.customer.displayName
                : ''
                }}
              </a>
            }
          </div>
          <div *dxTemplate="let cell of 'linkTemplate'">
            @if (cell) {
              <a [routerLink]="[]" [innerHtml]="cell.text" (click)="open(cell.data, cell.column.dataField)"></a>
            }
          </div>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (responses) {
              <span class="me-3">
                <strong>{{ quickbooksSyncResultsGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>

          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-state-storing [enabled]="true" [storageKey]="'quickbooks-sync-grid'"></dxo-data-grid-state-storing>
        </dx-data-grid>
      </div>
    </div>
  </div>
</div>
